import { render, staticRenderFns } from "./AppNavbarSecondary.vue?vue&type=template&id=3db59b05"
import script from "./AppNavbarSecondary.vue?vue&type=script&lang=ts"
export * from "./AppNavbarSecondary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports